import { render, staticRenderFns } from "./work-space-list.vue?vue&type=template&id=7cd9fe72&scoped=true&"
import script from "./work-space-list.vue?vue&type=script&lang=ts&"
export * from "./work-space-list.vue?vue&type=script&lang=ts&"
import style0 from "./work-space-list.vue?vue&type=style&index=0&id=7cd9fe72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd9fe72",
  null
  
)

export default component.exports